import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import apiClient from 'enrollment-platform/api/enrollment-platform-client/api-client'
import {
  GetInvoiceListRequestDto,
  GetInvoiceListResponseDto,
} from './dto/invoice-list.dto'

const getInvoiceList = async (
  request: GetInvoiceListRequestDto
): Promise<GetInvoiceListResponseDto> => {
  const response = await apiClient.get<GetInvoiceListResponseDto>(
    '/funding-invoice/invoice-deliveries',
    { params: request }
  )
  return response.data
}

export const useGetInvoiceList = (
  request: GetInvoiceListRequestDto,
  options?: Omit<
    UseQueryOptions<
      GetInvoiceListResponseDto,
      Error,
      GetInvoiceListResponseDto
    >,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery<GetInvoiceListResponseDto, Error, GetInvoiceListResponseDto>({
    queryKey: ['invoice-list', request],
    queryFn: () => getInvoiceList(request),
    ...options,
  })
}

export const downloadInvoiceExcel = async (
  invoiceId: string,
  originalFilename: string
): Promise<{ blob: Blob; filename: string }> => {
  const response = await apiClient.get<Blob>(
    `/funding-invoice/invoice-deliveries/${invoiceId}/excel`,
    { responseType: 'blob' }
  )
  const contentDisposition = response.headers['content-disposition']
  let filename = originalFilename
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="([^"]+)"/)
    if (match?.[1]) filename = match[1]
  }
  return { blob: response.data, filename }
}
